export const PAGE_TITLE = "Hypnotic Programming and Meditations";

export const PAGE_TEXT =
  "Explore our ever-growing <b>online library</b> of guided hypnosis and meditation sessions. These recordings are designed to support your personal and professional growth, featuring contributions from <b>Matthew J. Brownstein</b> and other <b>IIH graduates and practitioners.</b>";

export const VIDEO_URL =
  "https://drive.google.com/file/d/1yhXVe0gm2OBerS-6MGWY9cvxIetiT-Yz/preview";

export const YOUTUBE_OPTS = {
  height: "250px",
  width: "100%",
};

export const VIEW_MORE_LINK =
  "https://www.instituteofhypnotherapy.com/meditations-with-matthew/";

export const VIEW_MORE_LABEL = "View More";

export const MDITATION_VIDEOS = [
  {
    id: 1,
    video: "FevQUlcaYyE",
  },
  {
    id: 2,
    video: "duzXBE5AOuQ",
  },
  {
    id: 3,
    video: "Sb6sTmihjFc",
  },
  {
    id: 4,
    video: "vMcBTM341Qw",
  },
];
